import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Search, HelpCircle } from 'lucide-react';
import { faqs } from './faqData';
import { EMAIL_CONFIG } from './config/emailConfig';

const FAQs = () => {
  const [openFaqId, setOpenFaqId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  // Filtrar FAQs por término de búsqueda
  const getFilteredFAQs = () => {
    if (!searchTerm.trim()) {
      return faqs;
    }
    
    return faqs.filter(faq =>
      faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const toggleFaq = (faqId) => {
    setOpenFaqId(openFaqId === faqId ? null : faqId);
  };

  const filteredFaqs = getFilteredFAQs();

  return (
    <div className="min-h-screen bg-primary">
      <div className="max-w-4xl mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div 
            className="inline-flex items-center justify-center w-16 h-16 rounded-xl mb-4"
            style={{ background: 'var(--gradient-accent)' }}
          >
            <HelpCircle className="w-8 h-8 text-dark" />
          </div>
          <h1 className="text-4xl font-bold text-primary mb-3">
            Preguntas Frecuentes
          </h1>
          <p className="text-lg text-tertiary">
            Encuentra respuestas a las preguntas más comunes
          </p>
        </div>

        {/* Search Bar */}
        <div className="mb-8">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-tertiary w-5 h-5" />
            <input
              type="text"
              placeholder="Buscar pregunta..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 bg-overlay backdrop-blur-xl border border-light rounded-lg text-primary placeholder-slate-500 focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
            />
          </div>
        </div>

        {/* FAQ List */}
        {filteredFaqs.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-tertiary text-lg">
              No se encontraron preguntas que coincidan con tu búsqueda.
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {filteredFaqs.map(faq => (
              <div
                key={faq.id}
                className="bg-overlay backdrop-blur-xl rounded-lg border border-light hover:border-slate-600/50 transition-all"
              >
                <button
                  onClick={() => toggleFaq(faq.id)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-slate-700/30 transition-colors rounded-lg"
                >
                  <span className="text-lg font-medium text-primary pr-4">
                    {faq.question}
                  </span>
                  {openFaqId === faq.id ? (
                    <ChevronUp className="w-5 h-5 text-accent flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-tertiary flex-shrink-0" />
                  )}
                </button>

                {openFaqId === faq.id && (
                  <div className="px-6 pb-4 pt-2">
                    <div className="text-secondary leading-relaxed">
                      {faq.answer}
                    </div>
                    {faq.videoUrl && (
                      <div className="mt-4">
                        <div className="aspect-video bg-input rounded-lg flex items-center justify-center border border-light">
                          <p className="text-muted">Video próximamente</p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Contact CTA */}
        <div className="mt-12 bg-overlay backdrop-blur-xl rounded-lg p-8 text-center border border-light">
          <h3 className="text-2xl font-bold text-primary mb-2">
            ¿No encuentras lo que buscas?
          </h3>
          <p className="text-tertiary mb-4">
            Estamos aquí para ayudarte con cualquier duda adicional
          </p>
          <a
            href={`mailto:${EMAIL_CONFIG.info}`}
            className="inline-block px-6 py-3 rounded-lg font-medium transition-all hover:opacity-90"
            style={{ background: 'var(--gradient-accent-to-r)', color: 'var(--color-text-dark)' }}
          >
            Contactar Soporte
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQs;